import { render, staticRenderFns } from "./FinishRegistration.vue?vue&type=template&id=bfb0ae50&scoped=true"
import script from "./FinishRegistration.vue?vue&type=script&lang=js"
export * from "./FinishRegistration.vue?vue&type=script&lang=js"
import style0 from "./FinishRegistration.vue?vue&type=style&index=0&id=bfb0ae50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb0ae50",
  null
  
)

export default component.exports